export default "/img/strait.a5794531532026de0c06fd0666419928.jpg";